module.exports = __webpack_public_path__ + "576ac7f946f044bf345e29db69877bab.svg";